/**
 * Thomas Ford Ltd Theme JavaScript
 * Main functionality and interactions
 */

(function() {
  'use strict';

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initScrollAnimations();
    initMobileNav();
    initSearchToggle();
    initFilters();
  });

  /**
   * Scroll Animations - Reveal on Scroll
   */
  function initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
  }

  /**
   * Mobile Navigation Overlay
   * Note: Main mobile nav functionality is handled inline in header.liquid
   * This just adds the background overlay functionality
   */
  function initMobileNav() {
    const mobileNav = document.querySelector('.mobile-nav');
    if (!mobileNav) return;

    // Create overlay for background dimming
    const overlay = document.createElement('div');
    overlay.className = 'mobile-nav-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:1999;opacity:0;visibility:hidden;transition:all 0.3s ease;';
    document.body.appendChild(overlay);

    // Watch for mobile nav open/close
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          if (mobileNav.classList.contains('is-open')) {
            overlay.style.opacity = '1';
            overlay.style.visibility = 'visible';
          } else {
            overlay.style.opacity = '0';
            overlay.style.visibility = 'hidden';
          }
        }
      });
    });
    
    observer.observe(mobileNav, { attributes: true });

    // Close on overlay click
    overlay.addEventListener('click', function() {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /**
   * Search Toggle
   */
  function initSearchToggle() {
    const searchTrigger = document.querySelector('.header__search-trigger');
    if (!searchTrigger) return;

    searchTrigger.addEventListener('click', function() {
      // Implement search modal/drawer
      console.log('Search triggered');
    });
  }

  /**
   * Collection Filters (Mobile)
   */
  function initFilters() {
    const filterToggle = document.querySelector('.filter-toggle');
    const filters = document.querySelector('.filters');
    const filtersClose = document.querySelector('.filters__close');

    if (!filterToggle || !filters) return;

    filterToggle.addEventListener('click', function() {
      filters.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    if (filtersClose) {
      filtersClose.addEventListener('click', function() {
        filters.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  }

  /**
   * Add to Cart with AJAX
   */
  window.addToCart = function(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      // Update cart count
      updateCartCount();
      return data;
    })
    .catch(error => {
      console.error('Error:', error);
      throw error;
    });
  };

  /**
   * Update Cart Count
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  /**
   * Smooth Scroll
   */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  /**
   * Debounce Helper
   */
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Expose utilities globally
  window.ThomeFord = {
    addToCart: addToCart,
    updateCartCount: updateCartCount,
    debounce: debounce
  };

})();

/**
 * Product Form Handler
 */
if (document.getElementById('product-form')) {
  const productForm = document.getElementById('product-form');
  
  productForm.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');
    const originalText = submitButton.querySelector('.btn-text').textContent;
    
    // Disable button and show loading
    submitButton.disabled = true;
    submitButton.querySelector('.btn-text').textContent = 'Adding...';
    submitButton.classList.add('is-adding');
    
    const formData = {
      id: this.querySelector('[name="id"]').value,
      quantity: parseInt(this.querySelector('[name="quantity"]').value)
    };
    
    window.ThomeFord.addToCart(formData)
      .then(item => {
        // Show success
        submitButton.querySelector('.btn-text').textContent = 'Added!';
        
        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.querySelector('.btn-text').textContent = originalText;
          submitButton.classList.remove('is-adding');
        }, 2000);
      })
      .catch(error => {
        // Show error
        alert('Error adding to cart. Please try again.');
        submitButton.disabled = false;
        submitButton.querySelector('.btn-text').textContent = originalText;
        submitButton.classList.remove('is-adding');
      });
  });
}

/**
 * Lazy Loading Images
 */
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
        img.classList.remove('lazy');
        imageObserver.unobserve(img);
      }
    });
  });

  document.querySelectorAll('img.lazy').forEach(img => {
    imageObserver.observe(img);
  });
}
